/* oxlint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/
import iconSet from 'quasar/icon-set/material-icons.js'

import {Ripple,ClosePopup,Notify} from 'quasar'

export default { config: {},iconSet,directives: {Ripple,ClosePopup},plugins: {Notify} }
